import i18n from "@/i18n";
import copyToClipboard from "@/plugins/helper";

export default {
    install(Vue) {
        // Базовый метод
        Vue.prototype.$notification = function (options) {
            return this.$swal({
                showConfirmButton: false,
                ...options
            })
        }

        Vue.prototype.$notification.copy = function (target) {
            const message = i18n.t('messages.copied')
            copyToClipboard(target, () => {})
            return Vue.prototype.$swal({
                theme: "dark",
                position: "bottom",
                icon: "success",
                text: message,
                showConfirmButton: false,
                timer: 1000
            })
        }

        // Сокращения
        Vue.prototype.$notification.success = function (message = '', title = i18n.t('base.success')) {
            return Vue.prototype.$swal(title, message, 'success')
        }

        Vue.prototype.$notification.error = function (message = '', title = i18n.t('errors.error')) {
            return Vue.prototype.$swal(title, message, 'error')
        }

        // confirm диалог
        // ✅ confirm через колбэки
        Vue.prototype.$notification.confirm = function (
            successCallback,
            message = '',
            cancelCallback = null
        ) {
            Vue.prototype.$swal({
                title: i18n.t('base.sure'),
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: i18n.t('base.confirm'),
                cancelButtonText: i18n.t('base.cancel')
            }).then(result => {
                if (result.isConfirmed || result.value) {
                    successCallback()
                } else {
                    if (cancelCallback) cancelCallback()
                }
            })
        }
    }
}
